exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes slider{0%,to{background-image:url(/images/josh-rose-9YQGFzg0RiM-unsplash.jpg)}25%{background-image:url(/images/laura-vinck-Hyu76loQLdk-unsplash.jpg)}50%{background-image:url(/images/nitish-meena-RbbdzZBKRDY-unsplash.jpg)}75%{background-image:url(/images/preston-pownell-SwIQu6xODrI-unsplash.jpg)}}", ""]);

// exports
